<template>
  <div class="form">
    <el-form
      ref="form"
      status-icon
      :model="form"
      :rules="rules"
      label-width="100px"
    >
      <el-form-item label="原密码" prop="oPass">
        <el-input
          type="password"
          v-model="form.oPass"
          auto-complete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="pass">
        <el-input
          type="password"
          v-model="form.pass"
          auto-complete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认新密码" prop="checkPass">
        <el-input
          type="password"
          v-model="form.checkPass"
          auto-complete="off"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button style="width: 100%" type="primary" @click="onSubmit"
          >修改密码</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { OopsErrorELMessage, LogoutMixin, UserFormMixin } from "@/mixins";
export default {
  name: "ChangePassword",
  mixins: [OopsErrorELMessage, LogoutMixin, UserFormMixin],
  data() {
    return {
      form: {
        oPass: "",
        pass: "",
        checkPass: ""
      }
    };
  },
  methods: {
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          let uid = this.$store.getters.claim.id;
          this.$http
            .put(`/api/v1/users/${uid}/password`, {
              old_password: this.form.oPass,
              new_password: this.form.pass
            })
            .then(() => {
              this.$message({
                type: "success",
                message: "修改成功",
                duration: 1000
              });
              this.logout();
            })
            .catch(() => this.oopsError("修改密码失败"));
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.form {
  max-width: 500px;
  margin: 0 auto;
}
</style>
